import { TableColumnSortEnum } from 'CorePackage/MainModule/enums/TableColumnSortEnum';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

import { KnmListPlanIdCell } from '../components/KnmListPlanIdCell';
import { KnmListErpIdCell } from '../components/KnmListRenderErpId';
import { IKnmRaw } from '../interfaces/IKnmRaw';

export const initialKnmLIstTableColumns: ITableColumn<IKnmRaw>[] = [
  {
    id: 'erpId',
    name: 'Учетный № КНМ',
    sort: TableColumnSortEnum.DESC,
    renderCell: KnmListErpIdCell,
  },
  {
    id: 'planId',
    name: '№ плана КНМ',
    sort: TableColumnSortEnum.NONE,
    renderCell: KnmListPlanIdCell,
  },
  {
    id: 'startDateEn',
    name: 'Период проведения',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'district',
    name: 'Территориальная единица',
    sort: TableColumnSortEnum.NONE,
    isSelected: false,
  },
  {
    id: 'prosecutorOrganization',
    name: 'Орган прокуратуры',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'controllingOrganization',
    name: 'Контролирующий орган',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'status',
    name: 'Статус',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'federalLaw',
    name: 'ФЗ',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'knmType',
    name: 'Вид КНМ',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'inn',
    name: 'ИНН',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'ogrn',
    name: 'ОГРН',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'organizationName',
    name: 'Проверяемое лицо',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'approved',
    name: 'Решение по заявлению',
    sort: TableColumnSortEnum.NONE,
    isSelected: false,
  },
  {
    id: 'requirements',
    name: 'Обязательные требования',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'lists',
    name: 'Проверочные листы',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'statusEgrul',
    name: 'Статус проверяемого лица в ЕГРЮЛ',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'regDateEgrul',
    name: 'Дата государственной регистрации проверяемого лица в ЕГРЮЛ',
    sort: TableColumnSortEnum.NONE,
    isSelected: false,
  },
  {
    id: 'torRegistryExists',
    name: 'Наличие проверяемого лица в реестре ТОР(ТОСЭР)',
    sort: TableColumnSortEnum.NONE,
    isSelected: false,
  },
  {
    id: 'spvRegistryExists',
    name: 'Наличие проверяемого лица в реестрах СПВ',
    sort: TableColumnSortEnum.NONE,
    isSelected: false,
  },
  {
    id: 'sezRegistryExists',
    name: 'Наличие проверяемого лица в реестрах ОЭЗ(СЭЗ)',
    sort: TableColumnSortEnum.NONE,
    isSelected: false,
  },
  {
    id: 'resultEmpty',
    name: 'Наличие результата',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'hasViolations',
    name: 'Наличие нарушения',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'approveDocOrder',
    name: 'Номер и дата распоряжения (приказа)',
    sort: TableColumnSortEnum.NONE,
    isDisabledSort: true,
  },
  {
    id: 'createPlanDate',
    name: 'Дата создания плана',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'updatePlanDate',
    name: 'Дата последнего изменения плана',
    sort: TableColumnSortEnum.NONE,
  },
];
